<template lang="pug">
#contacts
  .main_container.container
    breadcrumb(v-bind:pageName="pageName")
    .row.mb-5.align-items-stretch
      .col-12.col-lg-6.mb-5
        about-us
      .col-12.col-lg-6.mb-5
        contact-us
  custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import AboutUs from "@/components/contacts/AboutUs";
import ContactUs from "@/components/contacts/ContactUs";
import Breadcrumb from "@/components/common/Breadcrumb";

export default {
  name: "Contacts",
  components: {
    "custom-footer": CustomFooter,
    "about-us": AboutUs,
    "contact-us": ContactUs,
    breadcrumb: Breadcrumb,
  },
  data() {
    return {
      pageName: "關於TOP巔峰",
    };
  },
};
</script>

<style scoped lang="scss">
#contacts {
  background: $color_bg_white;
}
</style>
